import { render, staticRenderFns } from "./static-image-element.vue?vue&type=template&id=2b4ffc8b"
import script from "./static-image-element.vue?vue&type=script&lang=js"
export * from "./static-image-element.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports